import * as React from "react";
import moment from "moment";

const VersionList: React.FunctionComponent<{
  versions?: any[];
  onView?: (docId: string) => void;
}> = (props) => {
  const getStatus = (proposalDocument: any) => {
    if (proposalDocument?.document?.internalApproval?.status === "Approved") {
      return "Internally Approved";
    }
    if (proposalDocument?.document?.internalApproval?.status === "Rejected") {
      return "Internally Rejected";
    }
    if (proposalDocument?.document?.internalApproval?.status === "Pending") {
      return "Internal Approval Pending";
    }
    return "Draft";
  };

  return !!props.versions?.length ? (
    <>
      <div className="">
        <div className="table-responsive bg-white">
          <table className="table table-bordered w-100">
            <tr>
              <th className="font-sm font-weight-semibold">Version</th>
              <th className="font-sm font-weight-semibold">Created By</th>
              <th className="font-sm font-weight-semibold">Created Date</th>
              <th className="font-sm font-weight-semibold">
                Client Acceptance & Agreed By
              </th>
              <th className="font-sm font-weight-semibold">
                Vendor/ Owner Acceptance & Agreed By
              </th>
              <th className="font-sm font-weight-semibold">Added Units</th>
              <th className="font-sm font-weight-semibold">Status</th>
            </tr>
            {props?.versions?.map((version) => {
              return (
                <tr
                  onClick={() => props.onView?.(version?._id)}
                  className="cursor-pointer"
                >
                  <td className="font-sm font-weight-semibold">
                    V{version.document?.versionNumber}
                  </td>
                  <td className="font-sm font-weight-semibold">
                    <div className="d-flex align-items-center">
                      {version.createdBy?.name}
                    </div>
                  </td>
                  <td className="font-sm font-weight-semibold">
                    {moment(version?.createdAt).format("DD MMM YYYY hh:mm A")}{" "}
                  </td>

                  <td className="font-sm font-weight-semibold">
                    {version?.signedClientDocument?.clientSignedBy && (
                      <>
                        <div className="d-flex align-items-center">
                          Agreed by{" "}
                          {
                            version?.signedClientDocument?.clientSignedBy
                              ?.fullName
                          }
                        </div>
                        <div>
                          <span className="text-gray-600">On</span>{" "}
                          {moment(
                            version?.signedClientDocument?.clientSignedAt
                          ).format("DD MMM YYYY hh:mm A")}{" "}
                        </div>
                      </>
                    )}
                  </td>
                  <td className="font-sm font-weight-semibold">
                    {version?.signedLandlordDocument?.landLordSignedBy && (
                      <>
                        <div className="d-flex align-items-center">
                          Agreed by{" "}
                          {
                            version?.signedLandlordDocument?.landLordSignedBy
                              ?.fullName
                          }
                        </div>
                        <div>
                          <span className="text-gray-600">On</span>{" "}
                          {moment(
                            version?.signedLandlordDocument?.landLordSignedAt
                          ).format("DD MMM YYYY hh:mm A")}{" "}
                        </div>
                      </>
                    )}
                  </td>
                  <td className="py-2 border-bottom">
                    <div className="py-1">
                    {version?.proposedPropertyDetails.map((item: any)=><div className="mb-1 font-xs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2">
                        Floor:{" "}
                        {
                          item?.propertyDetails
                            ?.propertyDetailsFromProject?.floor
                        }{" "}
                        / Unit:{" "}
                        {
                          item?.propertyDetails
                            ?.propertyDetailsFromProject?.unitName
                        }{" "}
                        / Area:{" "}
                        {
                          item?.propertyDetails
                            ?.propertyDetailsFromProject?.area
                        }
                      </div>)}
                    </div>
                  </td>
                  <td className="font-sm font-weight-semibold">
                    {!version?.document?.clientApproval &&
                    !version?.document?.landlordApproval ? (
                      <>{getStatus(version)}</>
                    ) : (
                      <>
                        {!!version?.document?.clientApproval && (
                          <>
                            {version?.document?.clientApproval.status ===
                            "Pending"
                              ? "Sent to Client"
                              : "Client Approved"}
                          </>
                        )}
                        {!!version?.document?.clientApproval &&
                          !!version?.document?.landlordApproval && <>{", "}</>}
                        {!!version?.document?.landlordApproval && (
                          <>
                            {version?.document?.landlordApproval.status ===
                            "Pending"
                              ? "Sent to Owner"
                              : "Vendor/Owner Approved"}
                          </>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default VersionList;
